import { gql } from '@apollo/client';

// Base Fragment For Media Schema Type
export const baseMediaFragment = gql`
  fragment BaseMedia on Media {
    __typename
    authenticated
    fileKey
    guid
    height
    id
    isLocked
    mediaId
    name
    size
    source
    thumbnailUrl
    url
    width
    transformation {
      __typename
      xAxis
      yAxis
      width
      height
      rotate
      startOffset
    }
    mediaStorageStatus {
      __typename
      id
      code
    }
    fileType {
      __typename
      id
      code
      name
    }
    mediaType {
      __typename
      id
      code
    }
    mediaStatus {
      __typename
      id
      code
    }
  }
`;

export const mediaAssetFragment = gql`
  fragment MediaAsset on Media {
    ...BaseMedia
    created
    __typename
  }
  ${baseMediaFragment}
`;

export const sidesMediaFragment = gql`
  fragment SidesMedia on Media {
    __typename
    id
    authenticated
    mediaId
    name
    mediaType {
      __typename
      id
      code
    }
  }
`;

export const baseMediaWithThumbnailFragment = gql`
  fragment BaseMediaWithThumbnail on Media {
    ...BaseMedia
    thumbnail {
      ...BaseMedia
      __typename
    }
    __typename
  }
  ${baseMediaFragment}
`;

export const profileMediaFragment = gql`
  fragment ProfileMediaWithThumbnail on ProfileMedia {
    id
    profileMediaId
    order
    isPrimary
    created
    __typename
    media {
      ...BaseMediaWithThumbnail
      __typename
    }
  }
  ${baseMediaWithThumbnailFragment}
`;

export const mediaAssetWithThumbnailFragment = gql`
  fragment MediaAssetWithThumbnail on Media {
    __typename
    ...MediaAsset
    thumbnail {
      __typename
      ...BaseMedia
    }
  }
  ${mediaAssetFragment}
  ${baseMediaFragment}
`;

export const mediaDetailsFragment = gql`
  fragment MediaDetails on Media {
    ...BaseMedia
    __typename
    transformations {
      __typename
      guid
      fileKey
      mediaStorageStatus {
        __typename
        code
      }
      thumbnailUrl
      mediaId
      url
      mediaType {
        __typename
        code
      }
    }
  }
  ${baseMediaFragment}
`;

export const photoAssetFragment = gql`
  fragment PhotoMediaAsset on Media {
    __typename
    id
    mediaId
    guid
    name
    created
    fileType {
      __typename
      id
      code
    }
    mediaType {
      __typename
      id
      code
    }
  }
`;

export const logoAssetFragment = gql`
  fragment LogoAsset on Media {
    __typename
    id
    url
    guid
    name
    fileKey
    mediaId
  }
`;

const baseWfMediaFragment = gql`
  fragment BaseWorkflowMedia on Media {
    __typename
    id: mediaId
    guid
    mediaId
    fileKey
    thumbnailUrl
    name
    url
    tag
    size
    mediaStorageStatus {
      __typename
      id
      code
    }
    fileType {
      __typename
      id
      code
      name
    }
    mediaType {
      __typename
      id
      code
    }
    mediaStatus {
      __typename
      id
      code
    }
    transformation {
      __typename
      xAxis
      yAxis
      width
      height
      rotate
    }
  }
`;

// Yes, it's basically the same as baseMediaFragment
// The difference is that the Schema (on WfMedia) is different
// And a couple of properties
export const wfMediaFragment = gql`
  fragment WorkflowMedia on Media {
    __typename
    ...BaseWorkflowMedia
    authenticated
    thumbnail {
      __typename
      ...BaseWorkflowMedia
    }
  }
  ${baseWfMediaFragment}
`;

// Same thing, but SubmissionMedia
// But in this case, we've got a lot of different properties
export const submissionMediaFragment = gql`
  fragment SubmissionMedia on SubmissionMedia {
    __typename
    id
    guid
    mediaId
    fileKey
    thumbnailUrl
    name
    url
    created
    isPrimary
    orderOfAppearance
    thumbnail {
      __typename
      ...BaseMedia
    }
    transformation {
      __typename
      xAxis
      yAxis
      width
      height
      rotate
    }
    mediaStorageStatus {
      __typename
      id
      code
    }
    fileType {
      __typename
      id
      code
    }
    mediaType {
      __typename
      id
      code
    }
    mediaStatus {
      __typename
      id
      code
    }
    __typename
  }
  ${baseMediaFragment}
`;

export const workflowCoverFragment = gql`
  fragment WorkflowCoverMedia on Media {
    __typename
    ...BaseWorkflowMedia
    thumbnail {
      __typename
      ...BaseWorkflowMedia
    }
    mediaStorageStatus {
      __typename
      id
      code
    }
    thumbnail {
      __typename
      ...BaseWorkflowMedia
    }
  }
  ${baseWfMediaFragment}
`;

export const coverFragment = gql`
  fragment CoverMedia on Media {
    __typename
    isLocked
    ...BaseMedia
    thumbnail {
      __typename
      ...BaseMedia
    }
  }
  ${baseMediaFragment}
`;

// Presentation media don't use all fields from mediaAssetWithThumbnailFragment
// so we need new one without redundant field
export const presentationMediaFragment = gql`
  fragment PresentationMedia on Media {
    __typename
    id
    mediaId
    fileKey
    name
    url
    mediaStorageStatus {
      __typename
      id
      code
    }
    fileType {
      __typename
      id
      code
    }
    mediaType {
      __typename
      id
      code
    }
    mediaStatus {
      __typename
      id
      code
    }
  }
`;

export const publicPresentationMediaFragment = gql`
  fragment PublicPresentationMedia on PresentationGroupMedia {
    __typename
    id
    name
    media {
      __typename
      ...BaseMedia
    }
  }
  ${baseMediaFragment}
`;
